import React from 'react';
import { Flex, Box, Image, VStack } from '@chakra-ui/react';
import { AuthLogo } from '../../assets/icons/auth-logo';
import bgImageLink from '../../assets/images/authBackground.jpg';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Flex minW="700px" h="100vh">
      {/* Левая половина с фоновым изображением и логотипом */}
      <Box bg="gray.200" w="50%" position="relative" overflow="hidden">
        {/* Фоновое изображение */}
        <Image
          src={bgImageLink}
          alt="Background"
          h="100%"
          w="100%"
          objectFit="cover"
          position="absolute"
        />

        {/* Логотип */}
        <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)">
          <AuthLogo />
        </Box>
      </Box>

      {/* Правая половина с формой авторизации */}
      <Box bg="white" w="50%" pt='101px' pb="110px">
        {/* Форма */}
        <VStack spacing={8} justify="center" h="100%">
          {children}
        </VStack>
      </Box>
    </Flex>
  );
};

export default AuthLayout;
